<div class="myunichoices-question question-type-choice">
  <h2 class="number" [innerHTML]="question.header | parseFormattedText" ngxBalanceText></h2>
  <div class="question" [innerHTML]="question.question | parseFormattedText" ngxBalanceText></div>
</div>



// WEBPACK FOOTER //
// ./src/app/components/questionnaire/questions/statement/statement.component.html